import { Injectable } from '@angular/core';

/** Configuración pública en tiempo de ejecución (assets/config.json). */
@Injectable({ providedIn: 'root' })
export class AppConfigService {
  apiUrl = '';

  async load(): Promise<void> {
    const respuesta = await fetch('assets/config.json', { cache: 'no-store' });
    if (!respuesta.ok) {
      throw new Error(`No se pudo cargar assets/config.json (${respuesta.status})`);
    }
    const config = await respuesta.json();
    this.apiUrl = String(config.apiUrl ?? '').replace(/\/+$/, '');
  }
}
